var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranscripts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1791_47239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0449 14.8099C20.0449 14.9372 19.9449 15.0372 19.8176 15.0372H10.954C10.7722 15.0372 10.5904 15.0917 10.4358 15.2008L5.95401 18.3008V15.9463C5.95401 15.4463 5.54492 15.0372 5.04492 15.0372H2.09038C1.9631 15.0372 1.8631 14.9372 1.8631 14.8099V2.99174C1.8631 2.86447 1.9631 2.76447 2.09038 2.76447H19.8176C19.9449 2.76447 20.0449 2.86447 20.0449 2.99174V14.8099ZM20.0449 0.946289H1.8631C0.863104 0.946289 0.0449219 1.75538 0.0449219 2.76447V15.0827C0.0449219 15.5554 0.235831 16.019 0.581285 16.3463C0.92674 16.6827 1.38129 16.8645 1.8631 16.8463H4.13583V20.0281C4.13583 20.3645 4.32674 20.6736 4.62674 20.8372C4.92674 20.9917 5.29038 20.9736 5.5631 20.7827L11.2358 16.8554H20.0449C21.0449 16.8554 21.8631 16.0463 21.8631 15.0372V2.76447C21.8631 1.76447 21.0449 0.946289 20.0449 0.946289Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49991 7.76447H16.409C16.909 7.76447 17.3181 7.35538 17.3181 6.85538C17.3181 6.35538 16.909 5.94629 16.409 5.94629H5.49991C4.99991 5.94629 4.59082 6.35538 4.59082 6.85538C4.59082 7.35538 4.99991 7.76447 5.49991 7.76447Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49991 11.8553H16.409C16.909 11.8553 17.3181 11.4462 17.3181 10.9462C17.3181 10.4462 16.909 10.0371 16.409 10.0371H5.49991C4.99991 10.0371 4.59082 10.4462 4.59082 10.9462C4.59082 11.4462 4.99991 11.8553 5.49991 11.8553Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1791_47239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8182,
    height: 20,
    transform: "translate(0.0449219 0.946289)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscripts);
export default __webpack_public_path__ + "static/media/transcripts.0586a41cae479700b75fec7840eaf152.svg";
export { ForwardRef as ReactComponent };